<div class="delete-popup-container" >
    <div class="delete-popup-text">Are you sure you want to delete this <br>{{text}}?</div>
    <div class="delete-popup-conform">
      <span (click)="close()">No</span>
      <span  (click)="submit()">Yes</span>
    </div>
</div>